import { Form } from '@unform/web';
import React, { useState } from 'react';
import { FaAngleDoubleUp } from 'react-icons/fa';
import FURGAPI from '../../services/api.furg';
import { getToken } from '../../services/auth';
import { decodeHexHtmlCharCodes, formattedDate } from '../../services/utils';
import { Alert } from '../Alert';
import { DocumentoHeader } from './DocumentoHeader';

const DocumentoCiencia = ({ onUpdate, vestibular, tipo_envio, documento, fase }) => {
    const documentacao_aceita = documento.documentacao_aceita || '';

    const getTypeHeader = () => {
        switch (fase) {
            case 'AN': // Antes Normal
            case 'N': // Normal
            case 'AR': // Antes do recurso (complementação)
                return !documento.nr_protocolo ? 'warning' : 'success';

            case 'R': // Fase de recurso(complementação)
                return documentacao_aceita === 'S' ? 'success' : !documento.nr_protocolo_recurso ? 'warning' : 'success';

            case 'F': // Fase final ou última
                if (['S', 'N'].includes(documento.recurso_aceito)) {
                    return documento.recurso_aceito === 'N' ? 'danger' : !documento.nr_protocolo_recurso ? 'warning' : 'success';
                }
                return documentacao_aceita === 'S' || !!documento.nr_protocolo_recurso ? 'success' : 'warning';
            default:
                break;
        }
    };

    return (
        <div className="row">
            <div className="d-flex col-12">
                <div className="flex-fill w-100 card">
                    <div className="card-header card-header--alert">
                        <DocumentoHeader type={getTypeHeader()}>{documento.tx_tipo_documento}</DocumentoHeader>
                        <CienciaInterna
                            id={documento.id_tipo_documento_candidato + 'fase1'}
                            idDoc={documento.id_tipo_documento_candidato}
                            protocolo={documento.nr_protocolo || ''}
                            dt_envio={documento.dt_envio}
                            parecer={documento.documentacao_parecer}
                            onUpdate={onUpdate}
                            vestibular={vestibular}
                            tipo_envio={tipo_envio}
                            disabled={tipo_envio !== 'N' || !!documento.nr_protocolo}
                            aceite={documentacao_aceita || ''}
                        >
                            <div className="accordion-title">Primeira fase</div>
                        </CienciaInterna>
                        {documentacao_aceita === 'N' && (
                            <>
                                <CienciaInterna
                                    id={documento.id_tipo_documento_candidato + 'fase2'}
                                    idDoc={documento.id_tipo_documento_candidato}
                                    protocolo={documento.nr_protocolo_recurso || ''}
                                    dt_envio={documento.dt_envio_recurso}
                                    parecer={documento.recurso_parecer}
                                    onUpdate={onUpdate}
                                    vestibular={vestibular}
                                    tipo_envio={tipo_envio}
                                    disabled={tipo_envio !== 'R' || !!documento.nr_protocolo_recurso}
                                    aceite={documento.recurso_aceito || ''}
                                >
                                    <div className="accordion-title">Complementação da documentação</div>
                                </CienciaInterna>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const CienciaInterna = ({ children, id, idDoc, protocolo, disabled, tipo_envio, dt_envio, aceite, parecer, vestibular, onUpdate }) => {
    const [error, setError] = useState('');
    const [checado, setChecado] = useState(!!protocolo);

    function handleSubmit({ data }) {
        FURGAPI.call('sischamamentos/Publico/gerarProtocoloEnvio', {
            token: getToken(vestibular),
            id_tipo_documento_candidato: idDoc,
            key: [],
        })
            .then(res => {
                const { dt_envio, nr_protocolo } = res;
                if (tipo_envio === 'N') {
                    onUpdate(idDoc, { dt_envio, nr_protocolo });
                } else if (tipo_envio === 'R') {
                    onUpdate(idDoc, { dt_envio_recurso: dt_envio, nr_protocolo_recurso: nr_protocolo });
                }
            })
            .catch(error => {
                setError(decodeHexHtmlCharCodes(error));
            });
    }

    return (
        <div className="card-body">
            <div className={'accordion accordion--alert ' + (protocolo ? 'collapsed' : '')} data-toggle="collapse" data-target={'#doc_' + id} aria-expanded="true" aria-controls={'#doc_' + id}>
                {children}
                <Alert variant={protocolo === '' && aceite === '' ? 'warning' : aceite === 'N' ? 'danger' : 'success'} icon={false}>
                    {protocolo === '' && aceite === '' ? (
                        <span>Você não declarou ciência</span>
                    ) : (
                        <>
                            <b>Protocolo:</b> {!!protocolo ? protocolo : 'Sem protocolo'}
                        </>
                    )}
                    <br />
                    {protocolo && (
                        <>
                            <b>Data de envio:</b> {formattedDate(dt_envio)} <br />
                        </>
                    )}
                    {aceite === 'N' && (
                        <>
                            <b>Avaliação: </b> Documentação indeferida pela comissão avaliadora <br />
                            {!!parecer && (
                                <>
                                    <b>Parecer: </b> {parecer}
                                </>
                            )}
                        </>
                    )}
                    {aceite === 'S' && (
                        <>
                            <b>Avaliação:</b> Documentação <b>aceita e deferida</b> pela comissão avaliadora
                            <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                        </>
                    )}
                    {protocolo && <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />}
                </Alert>
            </div>

            {!disabled && (
                <div id={'doc_' + id} className={'accordion-body collapse ' + (protocolo ? '' : 'show')} aria-labelledby={'#doc_' + id}>
                    <Form onSubmit={handleSubmit}>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <div className="label-text-documentos">
                            <div className="label-text-documentos__envio text-center">
                                <div className="d-flex justify-content-center">
                                    <input type="checkbox" id={`exampleCustomSwitch_${id}`} defaultChecked={checado} onChange={e => setChecado(e.target.checked)} disabled={disabled} />
                                    <label htmlFor={`exampleCustomSwitch_${id}`}>Declaro estar ciente</label>
                                </div>
                            </div>
                        </div>
                        <div className="accordion__rodape text-center mt-3">
                            {checado && (
                                <button type="submit" className="btn btn-primary">
                                    Confirmar envio
                                </button>
                            )}
                        </div>
                    </Form>
                </div>
            )}
        </div>
    );
};

export default DocumentoCiencia;
